function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import olStyleStyle from 'ol/style/Style';
import olStyleFill from 'ol/style/Fill';
import olStyleStroke from 'ol/style/Stroke';
import olStyleCircle from 'ol/style/Circle';
import olStyleIcon from 'ol/style/Icon';
import olStyleText from 'ol/style/Text';
import { LINE_DASH, LINE_JOIN, FILL_STYLE, STYLE_TYPE, PATTERN_STROKE } from './constants';
import { filterOptionalStyle, getOptionalStyleFilter } from './filter';
var log = Oskari.log('MapModule.util.style');
var TRANSPARENT = 'rgba(1,1,1,0)';
var merge = function merge() {
  var _jQuery;
  for (var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++) {
    styles[_key] = arguments[_key];
  }
  return (_jQuery = jQuery).extend.apply(_jQuery, [true, {}].concat(styles));
};
export var HIDDEN_STYLE = new olStyleStyle({
  visibility: 'hidden'
});
var defaultStyles = {};
export var setDefaultStyle = function setDefaultStyle(layerType, styleDef) {
  defaultStyles[layerType] = styleDef;
};
var getDefaultStyle = function getDefaultStyle(layerType) {
  return defaultStyles[layerType] || {};
};
var getFeatureStyle = function getFeatureStyle(layer) {
  var extendedDef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var style = layer.getCurrentStyle();
  var defaultDef = getDefaultStyle(layer.getLayerType());
  return merge(defaultDef, style.getFeatureStyle(), extendedDef);
};
export var useStyleFunction = function useStyleFunction(layer) {
  var current = layer.getCurrentStyle();
  var styleType = geometryTypeToStyleType(layer.getGeometryType());
  var hasPropertyLabel = Oskari.util.keyExists(current.getFeatureStyle(), 'text.labelProperty');
  var hasOptionalStyles = current.getOptionalStyles().length > 0;
  // TODO: should we check for -1 or undefined type? Seems it defaults to -1 and not 'undefined'
  var hasCluster = layer.getClusteringDistance() !== -1 && typeof layer.getClusteringDistance() !== 'undefined';
  return hasOptionalStyles || hasCluster || hasPropertyLabel || !styleType || styleType === STYLE_TYPE.COLLECTION;
};
export var geometryTypeToStyleType = function geometryTypeToStyleType(type) {
  var styleType;
  switch (type) {
    case 'LineString':
    case 'MultiLineString':
      styleType = STYLE_TYPE.LINE;
      break;
    case 'Polygon':
    case 'MultiPolygon':
      styleType = STYLE_TYPE.AREA;
      break;
    case 'Point':
    case 'MultiPoint':
      styleType = STYLE_TYPE.POINT;
      break;
    case 'GeometryCollection':
      styleType = STYLE_TYPE.COLLECTION;
      break;
    default:
      styleType = STYLE_TYPE.COLLECTION;
  }
  return styleType;
};

/**
 * @method getStyleForLayer
 * @param mapmodule
 * @param layer Oskari layer
 * @param extendedDef Oskari style definition which overrides layer's featureStyle
 * @return {ol/style/StyleLike}
 **/
export var getOlStyleForLayer = function getOlStyleForLayer(mapmodule, layer, extendedDef) {
  var featureStyle = getFeatureStyle(layer, extendedDef);
  var applyOpacity = mapmodule.getSupports3D();
  if (!applyOpacity && !useStyleFunction(layer)) {
    var styleType = geometryTypeToStyleType(layer.getGeometryType());
    return mapmodule.getStyle(featureStyle, styleType);
  }
  var typed = mapmodule.getGeomTypedStyles(featureStyle);
  var optional = layer.getCurrentStyle().getOptionalStyles().map(function (optionalDef) {
    return {
      filter: getOptionalStyleFilter(optionalDef),
      typed: mapmodule.getGeomTypedStyles(merge(featureStyle, optionalDef))
    };
  });
  return getStyleFunction({
    typed: typed,
    optional: optional
  }, layer, applyOpacity);
};
var _getStylesForGeometry = function getStylesForGeometry(geometry, styleTypes) {
  if (!geometry || !styleTypes) {
    return;
  }
  var geometries = [];
  var geomType = geometry.getType ? geometry.getType() : geometry;
  var type = geometryTypeToStyleType(geomType);
  if (type === STYLE_TYPE.COLLECTION) {
    if (typeof geometry.getGeometries === 'function') {
      geometries = geometry.getGeometries() || [];
    }
    if (geometries.length > 0) {
      log.debug('Received GeometryCollection. Using first feature to determine feature style.');
      return _getStylesForGeometry(geometries[0], styleTypes);
    } else {
      log.info('Received GeometryCollection without geometries. Feature style cannot be determined.');
    }
  }
  ;
  return styleTypes[type] || [];
};

// Style for cluster circles
export { _getStylesForGeometry as getStylesForGeometry };
var clusterStyleCache = {};
var clusterStyleFunc = function clusterStyleFunc(feature) {
  var size = feature.get('features').length;
  var cacheKey = "".concat(size);
  var style = clusterStyleCache[cacheKey];
  if (!style) {
    style = new olStyleStyle({
      image: new olStyleCircle({
        radius: size > 9 ? 14 : 12,
        stroke: new olStyleStroke({
          color: '#fff'
        }),
        fill: new olStyleFill({
          color: '#3399CC' // isSelected '#005d90'
        })
      }),
      text: new olStyleText({
        text: size.toString(),
        font: 'bold 14px sans-serif',
        fill: new olStyleFill({
          color: '#fff'
        })
      })
    });
    clusterStyleCache[cacheKey] = style;
  }
  return style;
};
export var getStyleFunction = function getStyleFunction(styles, layer, applyOpacity) {
  return function (feature) {
    var found = styles.optional.find(function (op) {
      return filterOptionalStyle(op.filter, feature);
    });
    var typed = found ? found.typed : styles.typed;
    var olStyles = _getStylesForGeometry(feature.getGeometry(), typed);
    // if typed is from optional styles and it doesn't have labelProperty, check if normal style has
    var _ref = typed || styles.typed,
      label = _ref.label;
    var textStyle = olStyles.length ? olStyles[0].getText() : undefined;
    if (textStyle) {
      _setFeatureLabel(feature, textStyle, label);
    }
    if (applyOpacity) {
      // apply opacity only for main style. other styles may use aplha for workarounds
      applyOpacityToStyle(olStyles[0], layer.getOpacity());
    }
    return olStyles;
  };
};
export var wrapClusterStyleFunction = function wrapClusterStyleFunction(styleFunction) {
  return function (feature) {
    // Cluster layer feature
    var feats = feature.get('features');
    if (feats) {
      if (feats.length > 1) {
        return clusterStyleFunc(feature);
      } else {
        // Only single point in cluster. Use it in styling.
        feature = feature.get('features')[0];
      }
    } else {
      // Vector layer feature, hide single points
      var geomType = feature.getGeometry().getType();
      if (geomType === 'Point' || geomType === 'MultiPoint' && feature.getGeometry().getPoints().length === 1) {
        return null;
      }
    }
    return styleFunction(feature);
  };
};
var applyAlphaToColorable = function applyAlphaToColorable(colorable, alpha) {
  if (!colorable || !colorable.getColor()) {
    return;
  }
  if (Array.isArray(colorable.getColor())) {
    var color = _toConsumableArray(colorable.getColor());
    color[3] = alpha;
    colorable.setColor(color);
    return;
  }
  var colorLike = colorable.getColor();
  if (typeof colorLike !== 'string') {
    return;
  }
  if (colorLike.startsWith('rgba')) {
    // null colors use transparent to avoid ol rendering default black color
    // 3D uses alpha for layer opacity. On opacity change alphas are updated.
    // Don't set alpha (opacity) for transparent color
    if (colorLike === TRANSPARENT) {
      return;
    }
    colorLike = colorLike.substring(0, colorLike.lastIndexOf(','));
    colorLike += ",".concat(alpha, ")");
    colorable.setColor(colorLike);
    return;
  } else if (colorLike.startsWith('rgb')) {
    colorLike = colorLike.replace('rgb', 'rgba');
    colorLike = colorLike.substring(0, colorLike.lastIndexOf(')'));
    colorLike += ",".concat(alpha, ")");
    colorable.setColor(colorLike);
    return;
  }
  var rgb = Oskari.util.hexToRgb(colorLike);
  if (!rgb) {
    return;
  }
  var r = rgb.r,
    g = rgb.g,
    b = rgb.b;
  colorable.setColor("rgba(".concat(r, ",").concat(g, ",").concat(b, ",").concat(alpha, ")"));
};
export var applyOpacityToStyle = function applyOpacityToStyle(olStyle, opacity) {
  if (!olStyle || isNaN(opacity)) {
    return;
  }
  var alpha = opacity <= 1 ? opacity : opacity / 100.0;
  applyAlphaToColorable(olStyle.getFill(), alpha);
  applyAlphaToColorable(olStyle.getStroke(), alpha);
  if (olStyle.getImage()) {
    olStyle.getImage().setOpacity(alpha);
  }
  return olStyle;
};
var _setFeatureLabel = function _setFeatureLabel(feature, textStyle) {
  var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var text = label.text,
    property = label.property;
  if (!property) {
    return;
  }
  var value;
  if (Array.isArray(property)) {
    var keyForFirstValue = property.find(function (p) {
      return feature.get(p);
    });
    value = feature.get(keyForFirstValue);
  } else {
    value = feature.get(property);
  }
  if (typeof value === 'undefined') {
    value = '';
  }
  var featureLabel = text ? text + ': ' + value : value;
  textStyle.setText(featureLabel);
};

/**
 * Creates style based on JSON
 * @param {AbstractMapModule} mapModule
 * @param styleDef Oskari style definition
 * @param geomType One of 'area', 'line', 'dot' | optional
 * @param requestedStyle layer's or feature's style definition (not overrided with defaults)
 * @return {Array} ol/style/Style. First item is main style and rest are optional/additional
 */
export var getOlStyles = function getOlStyles(mapModule, styleDef, geomType) {
  var requestedStyle = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var olStyles = [];
  var style = jQuery.extend(true, {}, styleDef);
  var olStyle = {};
  olStyle.fill = getFillStyle(style);
  if (style.stroke) {
    if (geomType === 'line') {
      delete style.stroke.area;
    }
    var olStroke = getStrokeStyle(style);
    olStyles.push.apply(olStyles, _toConsumableArray(getWorkaroundForDash(olStroke)));
    olStyle.stroke = olStroke;
  }
  if (style.image) {
    olStyle.image = getImageStyle(mapModule, style, requestedStyle);
  }
  if (style.text) {
    var textStyle = getTextStyle(style);
    if (textStyle) {
      olStyle.text = textStyle;
    }
  }
  var mainStyle = new olStyleStyle(olStyle);
  olStyles.unshift(mainStyle);
  return olStyles;
};

// draw transparent solid stroke to fire hover and click also on gaps with dashed stroke
// open layers renders only dashes so hover or click aren't fired on gaps
var getWorkaroundForDash = function getWorkaroundForDash(olStroke) {
  if (!olStroke) {
    // stroke with width 0 returns null as olStroke
    return [];
  }
  var lineDash = olStroke.getLineDash();
  if (!lineDash || !lineDash.length) {
    return [];
  }
  var transparent = olStroke.clone();
  applyAlphaToColorable(transparent, 0.01);
  transparent.setLineDash(null);
  var olStyle = new olStyleStyle({
    stroke: transparent
  });
  return [olStyle];
};

/**
 * @method getFillStyle
 * @param styleDef Oskari style definition
 * @return {ol/style/Fill} fill style
 */
var getFillStyle = function getFillStyle(styleDef) {
  if (!styleDef.fill) {
    return;
  }
  var color = styleDef.fill.color;
  if (!color) {
    return new olStyleFill({
      color: TRANSPARENT
    });
  }
  color = Oskari.util.getColorEffect(color, styleDef.effect);
  if (Oskari.util.keyExists(styleDef, 'fill.area.pattern')) {
    var pattern = getFillPattern(styleDef.fill.area.pattern, color);
    if (pattern) {
      return new olStyleFill({
        color: pattern
      });
    }
  }
  return new olStyleFill({
    color: color
  });
};

/**
 * @method getFillPattern
 * @param {Number} fillStyleCode Oskari style constant
 * @param {String} color color
 * @return {CanvasPattern} fill style
 */
var getFillPattern = function getFillPattern(fillStyleCode, color) {
  var canvasSize = 64;
  var _getFillPatternPath = getFillPatternPath(canvasSize, fillStyleCode),
    strokeWidth = _getFillPatternPath.strokeWidth,
    path = _getFillPatternPath.path;
  if (!path || !color) {
    return;
  }
  var canvas = document.createElement('canvas');
  canvas.width = canvasSize;
  canvas.height = canvasSize;
  var ctx = canvas.getContext('2d');
  ctx.lineCap = 'square';
  ctx.strokeStyle = color;
  ctx.lineWidth = strokeWidth;
  ctx.stroke(new Path2D(path));
  return ctx.createPattern(canvas, 'repeat');
};
export var getFillPatternPath = function getFillPatternPath(size, fillCode) {
  var THIN = PATTERN_STROKE.THIN,
    THICK = PATTERN_STROKE.THICK;
  var strokeWidth = THIN;
  var path;
  switch (fillCode) {
    case FILL_STYLE.THICK_DIAGONAL:
      strokeWidth = THICK;
    case FILL_STYLE.THIN_DIAGONAL:
      path = getDiagonalPattern(size, strokeWidth);
      break;
    case FILL_STYLE.THICK_HORIZONTAL:
      strokeWidth = THICK;
    case FILL_STYLE.THIN_HORIZONTAL:
      path = getHorizontalPattern(size, strokeWidth);
      break;
  }
  return {
    strokeWidth: strokeWidth,
    path: path
  };
};
var getDiagonalPattern = function getDiagonalPattern(size, lineWidth) {
  var whiteSpace = lineWidth * 2 + 2;
  var bandWidth = lineWidth + whiteSpace;
  var transition = size / Math.floor(size / bandWidth);
  var path = [];
  for (var t = transition / 2; t < size; t += transition) {
    path.push("M".concat(t, ",0"));
    path.push("L0,".concat(t));
  }
  for (var _t = transition / 2; _t < size; _t += transition) {
    path.push("M".concat(_t, ",").concat(size));
    path.push("L".concat(size, ",").concat(_t));
  }
  return path.join(' ');
};
var getHorizontalPattern = function getHorizontalPattern(size, lineWidth) {
  var whiteSpace = lineWidth + 2;
  var bandWidth = lineWidth + whiteSpace;
  var transition = size / Math.floor(size / bandWidth);
  var path = [];
  for (var y = transition / 2; y < size; y += transition) {
    path.push("M0,".concat(y));
    path.push("L".concat(size, ",").concat(y));
  }
  return path.join(' ');
};

/**
 * Parses stroke style from json
 * @method getStrokeStyle
 * @param {Object} style json
 * @return {ol/style/Stroke}
 */
var getStrokeStyle = function getStrokeStyle(styleDef) {
  var stroke = {};
  var strokeDef = styleDef.stroke.area ? styleDef.stroke.area : styleDef.stroke;
  var effect = strokeDef.effect || styleDef.effect;
  var width = strokeDef.width,
    color = strokeDef.color,
    lineDash = strokeDef.lineDash,
    lineCap = strokeDef.lineCap,
    lineJoin = strokeDef.lineJoin;
  if (width === 0) {
    return null;
  }
  stroke.color = color ? Oskari.util.getColorEffect(color, effect) : TRANSPARENT;
  if (width) {
    stroke.width = width;
  }
  if (lineDash) {
    if (Array.isArray(lineDash)) {
      stroke.lineDash = lineDash;
    } else {
      var getDash = function getDash(segment, gap) {
        return [segment, gap + (width || 0)];
      };
      switch (lineDash) {
        case LINE_DASH.DASH:
          stroke.lineDash = getDash(5, 4);
          break;
        case LINE_DASH.DOT:
          stroke.lineDash = getDash(1, 1);
          break;
        case LINE_DASH.DASHDOT:
          stroke.lineDash = getDash(5, 1).concat(getDash(1, 1));
          break;
        case LINE_DASH.LONGDASH:
          stroke.lineDash = getDash(10, 4);
          break;
        case LINE_DASH.LONGDASHDOT:
          stroke.lineDash = getDash(10, 1).concat(getDash(1, 1));
          break;
        case LINE_DASH.SOLID:
          stroke.lineDash = [];
          break;
        default:
          stroke.lineDash = [lineDash];
      }
    }
    stroke.lineDashOffset = 0;
  }
  if (lineCap) {
    stroke.lineCap = lineCap;
  }
  if (lineJoin) {
    if (lineJoin === LINE_JOIN.MITRE) {
      lineJoin = 'miter';
    }
    stroke.lineJoin = lineJoin;
  }
  return new olStyleStroke(stroke);
};

/**
 * Parses image style from json
 * @method getImageStyle
 * @param {Object} style json
 * @param {Object} requestedStyle layer's or feature's style definition (not overrided with defaults)
 * @return {ol/style/Circle}
 */
var getImageStyle = function getImageStyle(mapModule, styleDef, requestedStyle) {
  var opacity = styleDef.image.opacity || 1;
  // Oskari marker
  if (!isNaN(styleDef.image.shape)) {
    var _styleDef$image$fill;
    var effect = Oskari.util.getColorEffect((_styleDef$image$fill = styleDef.image.fill) === null || _styleDef$image$fill === void 0 ? void 0 : _styleDef$image$fill.color, styleDef.effect);
    var imageDef = _objectSpread({}, styleDef.image);
    if (effect) {
      imageDef.fill = {
        color: effect
      };
    }
    var _Oskari$custom$getSvg = Oskari.custom.getSvg(imageDef),
      src = _Oskari$custom$getSvg.src,
      scale = _Oskari$custom$getSvg.scale,
      _Oskari$custom$getSvg2 = _Oskari$custom$getSvg.offsetX,
      offsetX = _Oskari$custom$getSvg2 === void 0 ? 16 : _Oskari$custom$getSvg2,
      _Oskari$custom$getSvg3 = _Oskari$custom$getSvg.offsetY,
      offsetY = _Oskari$custom$getSvg3 === void 0 ? 16 : _Oskari$custom$getSvg3;
    return new olStyleIcon({
      src: src,
      scale: scale,
      anchorYUnits: 'pixels',
      anchorXUnits: 'pixels',
      anchorOrigin: 'bottom-left',
      anchor: [offsetX, offsetY],
      opacity: opacity
    });
  }
  var image = {};
  var size = mapModule.getDefaultMarkerSize();
  if (styleDef.image && styleDef.image.sizePx) {
    size = styleDef.image.sizePx;
  } else if (styleDef.image && styleDef.image.size) {
    size = mapModule.getPixelForSize(styleDef.image.size);
  }
  if (typeof size !== 'number') {
    size = mapModule.getDefaultMarkerSize();
  }
  styleDef.image.size = size;
  var fillColor = styleDef.image.fill ? styleDef.image.fill.color : undefined;
  fillColor = Oskari.util.getColorEffect(fillColor, styleDef.effect);
  if (mapModule.isSvg(styleDef.image)) {
    styleDef.image.color = fillColor;
    return new olStyleIcon({
      src: mapModule.getSvg(styleDef.image),
      size: [size, size],
      imgSize: [size, size],
      opacity: opacity
    });
  } else if (styleDef.image && styleDef.image.shape) {
    var _offsetX = !isNaN(styleDef.image.offsetX) ? styleDef.image.offsetX : 16;
    var _offsetY = !isNaN(styleDef.image.offsetY) ? styleDef.image.offsetY : 16;
    var iconOpts = {
      src: styleDef.image.shape,
      anchorYUnits: 'pixels',
      anchorXUnits: 'pixels',
      anchorOrigin: 'bottom-left',
      size: [size, size],
      anchor: [_offsetX, _offsetY],
      opacity: opacity
    };
    if (Oskari.util.keyExists(requestedStyle, 'image.fill.color')) {
      iconOpts.color = fillColor;
    }
    return new olStyleIcon(iconOpts);
  }
  if (styleDef.image.radius) {
    image.radius = styleDef.image.radius;
  } else {
    image.radius = 1;
  }
  if (styleDef.snapToPixel) {
    image.snapToPixel = styleDef.snapToPixel;
  }
  if (fillColor) {
    if (opacity !== 1) {
      var rgb = null;
      if (fillColor.charAt(0) === '#') {
        // check if color is hex
        rgb = Oskari.util.hexToRgb(fillColor);
        fillColor = 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + opacity + ')';
      } else if (fillColor.indexOf('rgb(') > -1) {
        // else check at if color is rgb
        var hexColor = '#' + Oskari.util.rgbToHex(fillColor);
        rgb = Oskari.util.hexToRgb(hexColor);
        fillColor = 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + opacity + ')';
      }
    }
    image.fill = new olStyleFill({
      color: fillColor
    });
  }
  if (styleDef.stroke) {
    image.stroke = getStrokeStyle(styleDef);
  }
  return new olStyleCircle(image);
};

/**
 * Parses JSON and returns matching ol/style/Text
 * @param  {Object} textStyleJSON text style definition
 * @return {ol/style/Text} parsed style or undefined if no param is given
 */
var getTextStyle = function getTextStyle(styleDef) {
  if (!styleDef || !styleDef.text) {
    return;
  }
  var text = {};
  var _styleDef$text = styleDef.text,
    scale = _styleDef$text.scale,
    offsetX = _styleDef$text.offsetX,
    offsetY = _styleDef$text.offsetY,
    rotation = _styleDef$text.rotation,
    textAlign = _styleDef$text.textAlign,
    textBaseline = _styleDef$text.textBaseline,
    font = _styleDef$text.font,
    fill = _styleDef$text.fill,
    stroke = _styleDef$text.stroke,
    labelText = _styleDef$text.labelText,
    overflow = _styleDef$text.overflow;
  if (scale) {
    text.scale = scale;
  }
  if (offsetX) {
    text.offsetX = offsetX;
  }
  if (offsetY) {
    text.offsetY = offsetY;
  }
  if (rotation) {
    text.rotation = rotation;
  }
  if (textAlign) {
    text.textAlign = textAlign;
  }
  if (textBaseline) {
    text.textBaseline = textBaseline;
  }
  if (font) {
    text.font = font;
  }
  if (overflow) {
    text.overflow = !!overflow;
  }
  if (fill && fill.color) {
    text.fill = new olStyleFill({
      color: Oskari.util.getColorEffect(fill.color, styleDef.effect)
    });
  }
  if (stroke) {
    text.stroke = getStrokeStyle(styleDef.text);
  }
  if (labelText) {
    if (typeof labelText === 'number') {
      text.text = labelText.toString();
    } else {
      text.text = labelText;
    }
  }
  return new olStyleText(text);
};